<template>
  <div>
    <div class="vx-row">
      <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
        <vx-card class="mb-4">
          <div class="vx-row">
            <!-- Avatar Col -->
            <div class="vx-col" id="avatar-col" >
              <div class="img-container mb-4">
                <img
                  :src="accounts.avatar_url"
                  v-if="typeof accounts.avatar_url !== 'undefined' && accounts.avatar_url !== null && accounts.avatar_url.length > 0"
                  class="myAccountPhoto rounded w-full" />

                <img
                  src="@/assets/images/portrait/default.jpg"
                  v-else
                  class="myAccountPhoto rounded w-full" />
              </div>
            </div>

            <div class="avatar-name">
              <h3 v-text="accounts.name"></h3>
            </div>
          </div>

          <div>
            <vs-list>
              <vs-list-item class="pt-4 pb-4" :title="$t('email')">
                <badge-clipboard v-if="accounts.email" :text="accounts.email"></badge-clipboard>
              </vs-list-item>

              <vs-list-item class="pt-4 pb-4" :title="$t('mobile_number')">
                <badge-clipboard class="mb-1" v-if="accounts.mobile" :text="accounts.mobile"></badge-clipboard>
              </vs-list-item>

              <vs-list-item class="pt-4 pb-4" :title="$t('landline_number')">
                <badge-clipboard class="mb-1" v-if="accounts.landline" :text="accounts.landline"></badge-clipboard>
              </vs-list-item>
            </vs-list>

            <my-account-user-nav-button class="w-full mb-2" :title="$t('personal_information')" icon="icon-user" route="my-account.personal-information"></my-account-user-nav-button>
            <my-account-user-nav-button class="w-full mb-2" :title="$t('change_password')" icon="icon-lock" route="my-account.change-password"></my-account-user-nav-button>
          </div>
        </vx-card>
      </div>

      <div class="vx-col md:w-3/4 sm:w-3/4 w-full">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import MyAccount from '@/models/MyAccount'
import { EventBus } from '@/../eventbus.js'
import MyAccountUserNavButton from '@/components/navigations/MyAccountUserNavButton'

export default {
  name: 'Admin.MyAccount',
  components: {
    MyAccountUserNavButton
  },
  data () {
    return {
      accounts: {}
    }
  },
  mounted () {
    this.loadMyAccountList()

    EventBus.$on('myAccountUpdated', () => {
      this.loadMyAccountList()
    })
  },
  methods: {
    async loadMyAccountList () {
      const response = await MyAccount.findAll()
      this.accounts = response.data.accounts
    }
  }
}
</script>

<style lang="scss" scoped>
  .myAccountPhoto {
    max-width: 100px;
    width: 100%;
  }

  .avatar-name {
    h3 {
      text-transform: capitalize;
    }
  }
</style>
